import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { postSendSms, SendSmsRequest, SendSmsResponse } from "../index";

/**
 * SMS 인증번호 전송 Hook
 */
export const usePostSendSms = (
  options?: UseMutationOptions<SendSmsResponse, Error, SendSmsRequest>
) => {
  return useMutation<SendSmsResponse, Error, SendSmsRequest>({
    mutationFn: postSendSms,
    ...options,
  });
};

